import React from 'react';
import { useTranslation } from 'react-i18next';
import Hint from './hint';

interface Props {
  maxLength: number;
  currentLength: number;
  className: string;
}

const DEFAULT_TRANSLATION_KEY = 'signup-flow.domain.free.hint.username-length.default.text';
const MAXLENGTH_TRANSLATION_KEY = 'signup-flow.domain.free.hint.username-length.maxlength.text';

function replacePlaceholders(text: string, maxLength: number, currentLength: number): string {
  return text
    .replace('{MAX_LENGTH}', String(maxLength))
    .replace('{REMAINING_LENGTH}', String(maxLength - currentLength));
}

const UsernameMaxLengthHint: React.SFC<Props> = ({ maxLength, currentLength, className }) => {
  const { t } = useTranslation();

  const key = maxLength === currentLength ? MAXLENGTH_TRANSLATION_KEY : DEFAULT_TRANSLATION_KEY;
  const text = t(key);

  return <Hint className={className} html={replacePlaceholders(text, maxLength, currentLength)} />;
};

export default UsernameMaxLengthHint;
